import { gsap } from 'gsap'
import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

export default {
  init() {
    console.log('product');

    new Swiper('.swiperProdotti', {
		modules: [Navigation],
		slideToClickedSlide: false,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			900: {
				slidesPerView: 2,
			},
			640: {
				slidesPerView: 1,
			},
		},
		loop: true,
	});

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
